import { render, staticRenderFns } from "./ControlBasicInformation.vue?vue&type=template&id=e646a332&scoped=true"
import script from "./ControlBasicInformation.vue?vue&type=script&lang=js"
export * from "./ControlBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./ControlBasicInformation.vue?vue&type=style&index=0&id=e646a332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e646a332",
  null
  
)

export default component.exports